declare global {
  interface String {
    shorted(maxLength?: number, ending?: string): string;
    ucfirst(): string;
  }
}

String.prototype.shorted = function (maxLength = 100, ending = '...') {
  if (!this) return '-'
  
  if (this.length > maxLength) {
    return this.substring(0, maxLength) + ending
  }

  return this
}

String.prototype.ucfirst = function () {
  if (typeof this !== "string") return "";
  return this.charAt(0).toUpperCase() + this.slice(1);
};

export {}